import React, { memo, HTMLProps } from "react";
import classnames from "classnames";
import Element from "src/components/base/element";
import styles from "./media.module.scss";

interface IProps extends HTMLProps<HTMLElement> {
    className?: string;
    children: React.ReactNode;
}

function MediaRight(props: IProps) {
    const { className, children, ...rest } = props;
    return (
        <Element
            {...rest}
            className={classnames(
                "media-right",
                "basis-auto grow-0 shrink-0",
                "ml-[10px]",
                className
            )}
        >
            {children}
        </Element>
    );
}

export default memo(MediaRight);
